const defaultPortions = { adult: 1, preteen: 1, child: 0.5 };

const memberDataFields = [
    'birthdate',
    'gender',
    'pregnant',
    'lactating',
    'due_date',
    'fetus_count',
    'height_cm',
    'weight_kg',
    'weight_lbs',
    'goal_weight_kg',
    'goal_weight_lbs',
    'activity_level',
    'target_energy_kcal',
];

export function hasNameOrData(member) {
    return !/^(Adult|Preteen|Child) #\d+$/.test(member.name)
        || member.portion !== defaultPortions[member.type]
        || memberDataFields.some((field) => member[field]);
}
